import BeatLoader from "react-spinners/BeatLoader";
import React from "react";

const ButtonLoading = ({ size = 10 }) => <BeatLoader size={size} />;

export default ButtonLoading;
